import { render, staticRenderFns } from "./Paypassword.vue?vue&type=template&id=2b0f9482&scoped=true&"
import script from "./Paypassword.vue?vue&type=script&lang=js&"
export * from "./Paypassword.vue?vue&type=script&lang=js&"
import style0 from "./Paypassword.vue?vue&type=style&index=0&id=2b0f9482&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0f9482",
  null
  
)

/* custom blocks */
import block0 from "./Paypassword.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports